import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { NgSelectModule } from "@ng-select/ng-select";
import { TranslateModule } from "@ngx-translate/core";
import { IonicPageModule } from "ionic-angular";
import { TruncateModule } from "ng2-truncate";
import { CommonComponentsModule } from "../../../components/common/common-components.module";
import { ComponentsModule } from "../../../components/components.module";
import { CompanyPageModule } from "../company.module";
import { FacilitiesView } from "../facilities-view/facilities-view";
import { LocationTeams } from "../location-teams/location-teams";
import { LocationTeamsDetails } from "../location-teams/location-teams-details/location-teams-details";
import { CompanyDetailsPageModule } from "../locations/locations.module";
import { PayersView } from "../payers-view/payers-view";
import { LocationGroup } from "./location-group";

@NgModule({
  declarations: [
    LocationGroup,
    LocationTeams,
    LocationTeamsDetails,
    FacilitiesView,
    PayersView,
  ],
  imports: [
    CommonComponentsModule,
    IonicPageModule.forChild(LocationGroup),
    TranslateModule,
    ComponentsModule,
    CompanyPageModule,
    NgSelectModule,
    CompanyDetailsPageModule,
    TruncateModule,
  ],
  exports: [LocationTeams, FacilitiesView, PayersView],
  entryComponents: [LocationTeams, FacilitiesView, PayersView],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class LocationGroupModule {
  static getLocationTeamsComponent() {
    return LocationTeams;
  }
}



// WEBPACK FOOTER //
// ./src/pages/company/location-group/location-group.module.ts